import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=88d544aa&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88d544aa')) {
      api.createRecord('88d544aa', component.options)
    } else {
      api.reload('88d544aa', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=88d544aa&", function () {
      api.rerender('88d544aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2F49R00KfE3Gz/JS/imageCarousel.vue"
export default component.exports